import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase"; // Adjust path if needed

// Custom Hook to manage Admin Auth State globally
const useAdminAuth = () => {
  const [state, setState] = useState({ isLoading: true, isAdmin: false });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({ isLoading: false, isAdmin: false });
        return;
      }
      try {
        const adminDoc = await getDoc(doc(db, "admins", user.uid));
        if (adminDoc.exists() && adminDoc.data().status === "Active") {
          // MUTUAL EXCLUSIVITY: Destroy Retailer session if Admin is active
          localStorage.removeItem("retailerSession");
          setState({ isLoading: false, isAdmin: true });
        } else {
          setState({ isLoading: false, isAdmin: false });
        }
      } catch (error) {
        console.error("Admin verification error:", error);
        setState({ isLoading: false, isAdmin: false });
      }
    });
    return () => unsubscribe();
  }, []);

  return state;
};

// UI for loading states
const SecurityLoader = ({ text }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "#020617",
      color: "#94a3b8",
      fontFamily: "Inter, sans-serif",
    }}
  >
    {text}
  </div>
);

// 🔒 PROTECTED ROUTE: Only Admins can enter. Kicks others to login.
export const RequireAdmin = () => {
  const { isLoading, isAdmin } = useAdminAuth();
  if (isLoading)
    return <SecurityLoader text="Verifying Admin Security Clearance..." />;
  return isAdmin ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

// 🚪 GUEST ROUTE: Only non-admins can see the login page. Kicks Admins to dashboard.
export const GuestAdmin = () => {
  const { isLoading, isAdmin } = useAdminAuth();
  if (isLoading) return <SecurityLoader text="Checking Admin Session..." />;
  return isAdmin ? <Navigate to="/admin" replace /> : <Outlet />;
};
